module.exports = __webpack_public_path__ + "img/3.031c21c3.jpg";